<!-- 图书柜-我要买书-支付 -->
<template>
  <div class="BookcaseSCloceBox">
    <div class="successBox">
      <template v-if="$store.state.eUserInfo.operateType == 'save'">
        <p class="text">商品已入库</p>
        <p class="pText">商品卖出后，￥{{$store.state.ECMall_activeGoods.send_price}}将存入到您的微信钱包里</p>
      </template>
      <p class="text" v-else>商品已出库</p>
      <p class="bbtn-continue" @click="goMySell">查看在卖商品</p>
    </div>
  </div>
</template>

<script>
  import { storage } from '../../../../static/js/utils/utility'
  let vm, timer

  export default {
    name:'BookcaseSCloceBox',
    components: {
    },
    computed: {
    },
    data() {
      return {
      }
    },
    created() {
      vm = this
    },
    mounted () {
      console.log('this', this.$route)
    },
    methods: {
      // 查看在卖商品
      goMySell () {
        vm.$store.state.ECMall_activeGoods = {}
        vm.$store.state.eUserInfo.operateType = ''
        vm.$router.replace('/Bookcase/MySell')
      },
      // 去支付
      goPay () {
        vm.$router.push('/Bookcase/Pay')
      }
    },
    watch: {
    },
  }
</script>

<style lang="less">
.Bookcase{
  .BookcaseSCloceBox {
    width: 100%;
    height: 100%;
    padding: 0.52rem 0.42rem 0.62rem;
    display: flex;
    flex-direction: column;
    .box {
      width: 100%;
      height: 100%;
      margin: 0 auto;
      background-color: #ffffff;
      box-shadow: 0 0.02rem 0.24rem rgba(0, 0, 0, 0.21);
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bookcase/Sell/SCloseBox.vue